<template>
	<div id="addPosition">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->

			<div class="companyInfoIpt">
				<div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						{{id?'编辑职位':'新增职位'}}
					</div>
				</div>

				<div class="iptContainer">

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>招聘类型：
						</div>
						<el-radio-group fill="#1E40AF" v-model="radio1" @input='inputChange'>
							<el-radio-button label="全职" value='1'></el-radio-button>
							<el-radio-button label="实习" value='2'></el-radio-button>
							<!-- 	<el-radio-button label="兼职" value='3'></el-radio-button> -->
						</el-radio-group>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>职位名称：
						</div>
						<el-input v-model="job_name" maxlength="20" placeholder="请输入职位名称"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>职位类型：
						</div>
						<div class="majorbox" @click="selectcityBox5">
							<div class="majorBox one-line" :style="job_title!==''?'':'color:#b4bccc;'">
								{{job_title!==''?job_title:'职位类型'}}
							</div>
							<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
						</div>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>职位描述：
						</div>
						<el-input v-model="job_desc" type="textarea" :maxlength="2000" autosize
							placeholder="建议按如下四点输入职位描述：
1.职位职责
2.任职要求
3.职位福利
4.发展空间"></el-input>


						<!--  <div class="tinyEditor">
                          <Tinymce ref="editor" v-model="job_desc" :height="300" :width="900" />
                        </div> -->

					</div>
					
					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>薪资范围：
						</div>
						<el-select v-model="salary_min" placeholder="请选择" @change='changeSalay1'>
							<el-option v-for="item in salaryArry1" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					
						<el-select v-model="salary_max" :placeholder="`请选择，不选默认（${salary_min}k+）`" v-if="isshow"
							style="margin-left: 10px;">
							<el-option v-for="item in salaryArry2" :disabled='salaryDisabled' :key="item.value"
								:label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							薪资构成：
						</div>
						<el-input v-model="salary_composition" type="textarea" autosize placeholder="完整填写可提升50%职位吸引力。
请尽量注明：1.年薪范围，2.无责底薪，3.绩效，4.奖金补贴，5.社保类型。
如：年薪15-20万，无责底薪10k，绩效0-3k，年终2-3个月，交通餐补500元/月，六险一金。"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>最低学历：
						</div>
						<el-select v-model="education" placeholder="请选择最低学历">
							<el-option v-for="(item,index) in eduList" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							目标院校：
						</div>
						<div class="majorbox" @click="selectcityBox1">
							<div class="majorBox one-line" :style="intend_school_name.length>0?'':''">
								{{intend_school_name.length>0?intend_school_name.join('，'):'不限院校'}}
							</div>
							<i class="el-icon-arrow-down" style="color:#c0c4cc;font-size: 14px;"></i>
						</div>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							目标专业：
						</div>
						<div class="majorbox" @click="selectMajorBox">
							<div class="majorBox one-line" :style="major_name.length>0?'':''">
								{{major_name.length>0?major_name.join('，'):'不限专业'}}
							</div>
							<i class="el-icon-arrow-down" style="color:#c0c4cc;font-size: 14px;"></i>
						</div>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							招聘对象：
						</div>
						<el-select v-model="graduationDate" multiple placeholder="请选择招聘对象">
							<el-option v-for="(item,index) in graduationDateList" :key="index" :label="item"
								:value="item">
							</el-option>
						</el-select>
					</div>


					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							职位关键词：
						</div>
						<el-select v-model="highlights" multiple allow-create filterable @change='selectChange' :disabled='jobTitleDisabled'
							filterable placeholder="请选择/添加职位关键词">
							<el-option v-for="(item,index) in highlightsList" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>工作地点：
						</div>
						<div class="environment" @click="openDialogVisible"
							:style="work_place!==''?'color:#000000;display:block':'color:#c0c4cc;display:block'">
							{{work_place==''?'请选择工作地点':work_place}}
						</div>
					</div>

					<!-- <div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							上班时间：
						</div>
						<div class="majorbox" @click="selectcityBox5">
							<div class="majorBox one-line" :style="job_title!==''?'':'color:#b4bccc;'">
								{{job_title!==''?job_title:'上班时间'}}
							</div>
							<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
						</div>
					</div> -->

					
					
					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							工作时间：
						</div>
						<div class="environment" @click="openDialogVisible2"
							:style="officeEnvironment1=='已添加'?'color:#000000;':'color:#c0c4cc;'">
							{{officeEnvironment1}}
						</div>
					</div>
					
					<!-- <div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							休假制度：
						</div>
						<el-select v-model="wayResting" placeholder="请选择休假制度">
							<el-option v-for="(item,index) in workList1" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>
					
					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>工作时间：
						</div>
						<el-time-select placeholder="起始时间" v-model="startTime" :picker-options="{...pickerOptions1}"
							style="margin-right: 10px;">
						</el-time-select>

						<el-time-select placeholder="结束时间" v-model="endTime"
							:picker-options="{...pickerOptions2,minTime: startTime}">
						</el-time-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							加班需求：
						</div>
						<el-select v-model="acceptance_of_overtime" allow-create default-first-option
							placeholder="请选择加班需求">
							<el-option v-for="(item,index) in workList" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div> -->
					
					


					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							出差需求：
						</div>
						<el-select v-model="acceptance_of_outwork" placeholder="请选择出差需求">
							<el-option v-for="(item,index) in overtimeList" :key="index" :label="item" :value="item">
							</el-option>
						</el-select>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>招聘人数：
						</div>
						<el-input v-model="job_num" type="number" max="100" maxlength="3" clearable placeholder="请输入招聘人数"
							@input='setJobNum'></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							招聘截止时间：
						</div>
						<el-date-picker v-model="job_end_time" :picker-options="pickerOptions" type="date"
							placeholder="请选择截止时间">
						</el-date-picker>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							期望求职者性格：
						</div>
						<div class="environment" @click="openque1" style="color:#c0c4cc;cursor: pointer;">
							<div class="" style="flex: 1;" :style="isque1Select?'color:#606266;':''">
								{{isque1Select?'已选择':'请选择'}}
							</div>
							<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
						</div>

					</div>


					<!-- <div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>领导介绍：
						</div>
						<el-input type="textarea" autosize placeholder="请输入领导介绍" v-model="textarea1">
						</el-input>
					</div> -->
					
					<!-- <div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							直属领导介绍：
						</div>
						<div class="environment" @click="openDialogVisible2"
							:style="officeEnvironment1=='已添加'?'color:#000000;':'color:#c0c4cc;'">
							{{officeEnvironment1}}
						</div>
					</div> -->

					



					<!-- <div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							人才培养发展规划：
						</div>
						<el-input type="textarea" autosize placeholder="请输入人才培养与发展规划" v-model="career_planning">
						</el-input>
					</div> -->








					<template v-if="job_type==2">

						<div class="ipt" style="margin-bottom: 30px;">
							<div class="text">
								实习月数不低于：
							</div>
							<el-select v-model="intern_month" placeholder="请选择实习月数">
								<el-option v-for="(item,index) in internMonthList" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
						<div class="ipt" style="margin-bottom: 30px;">
							<div class="text">
								到岗天数不低于：
							</div>
							<el-select v-model="intern_date" placeholder="请选择每周到岗天数">
								<el-option v-for="(item,index) in internDateList" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>

						<div class="ipt" style="margin-bottom: 30px;">
							<div class="text">
								转正机会：
							</div>
							<el-select v-model="intern_becoming_full" placeholder="请选择转正机会">
								<el-option v-for="(item,index) in internBecomingList" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
					</template>

					<template v-if="job_type==3">
						<div class="ipt" style="margin-bottom: 30px;">
							<div class="text">
								兼职类别：
							</div>
							<el-select v-model="parttime_category" placeholder="请选择兼职类别">
								<el-option v-for="(item,index) in parttimeCategoryList" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
					</template>

					<template v-if="job_type==2||job_type==3">
						<div class="ipt" style="margin-bottom: 30px;">
							<div class="text">
								结算方式：
							</div>
							<el-select v-model="intern_account_type" placeholder="请选择结算方式">
								<el-option v-for="(item,index) in internAccountList" :key="index" :label="item"
									:value="item">
								</el-option>
							</el-select>
						</div>
					</template>
					<!-- <template>
						
					</template> -->










					<!-- <div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							求职期望匹配：
						</div>
						<div class="environment" @click="openque2" style="color:#c0c4cc;cursor: pointer;">
							<div class="" style="flex: 1;" :style="isque2Select?'color:#606266;':''">
								{{isque2Select?'已选择':'请选择'}}
							</div>
							<i class="el-icon-arrow-down" style="color:#c0c4cc;"></i>
						</div>
					</div> -->


				</div>
				<div class="btnContainer">
					<el-button type="primary" class="submit" v-if="id" @click="getQrcode">职位预览</el-button>
					<el-button type="primary" class="submit" @click="publish(0)">保存</el-button>
				</div>
			</div>
		</div>



		<el-dialog title="地址管理" :visible.sync="dialogVisible" :close-on-click-modal='false' width="600px">
			<el-button type="primary" @click="openDialogVisible1()" class="preview">新增地址</el-button>
			<div class="addressList">
				<div class="item" v-for="(item,index) in addressArr" :key="index">
					<div class="addressLeft">
						<div class="top">
							{{item.work_province}}{{item.work_city|cityfilters}}{{item.work_county}}
						</div>
						<div class="bottom">
							{{item.address}}
						</div>
					</div>
					<div class="addressRight" @click="changeAddressIndex(index)">
						<img src="../img/selected.png" alt="" v-if="addressIndex===index" />
						<img src="../img/select.png" alt="" v-else />
					</div>
				</div>
			</div>
			<el-empty description="暂无地址" v-if="addressArr.length==0"></el-empty>
			<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
				<el-button type="danger" class="preview" @click="deleteAddress">删除</el-button>
				<el-button type="primary" class="preview" @click="submitAddress1">确认</el-button>
			</div>
		</el-dialog>
		
		<el-dialog title="新增地址" :visible.sync="dialogVisible1" :close-on-click-modal='false' width="800px">
			<div class="addressList">
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						省市区：
					</div>
					<el-cascader v-model="address" placeholder="请选择" :options="addressList" filterable
						:props="{ children:'list',value:'label' }"></el-cascader>
				</div>
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						详细地址：
					</div>
					<el-input v-model="detailedAddress" placeholder="请输入详细地址"></el-input>
				</div>
			</div>
			<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
				<el-button type="primary" class="preview" @click="submitAddress">确认</el-button>
			</div>
		</el-dialog>

		<el-dialog title="工作时间" :visible.sync="dialogVisible2" @close='elDialogClose1' :close-on-click-modal='false' width="600px"
			:before-close="handleClose">
		
			<div class="elDialogContainer">
		
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						休假制度：
					</div>
					<el-select v-model="wayResting" placeholder="请选择休假制度">
						<el-option v-for="(item,index) in workList1" :key="index" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
				
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						工作时间：
					</div>
					<el-time-select placeholder="起始时间" v-model="startTime" :picker-options="{...pickerOptions1}"
						style="margin-right: 10px;">
					</el-time-select>
				
					<el-time-select placeholder="结束时间" v-model="endTime"
						:picker-options="{...pickerOptions2,minTime: startTime}">
					</el-time-select>
				</div>
				
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						加班需求：
					</div>
					<el-select v-model="acceptance_of_overtime" allow-create default-first-option
						placeholder="请选择加班需求">
						<el-option v-for="(item,index) in workList" :key="index" :label="item" :value="item">
						</el-option>
					</el-select>
				</div>
		
			</div>
			<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
				<el-button type="primary" @click="submit2">保存</el-button>
			</div>
		</el-dialog>

		<!-- <el-dialog title="直属领导" :visible.sync="dialogVisible2" @close='elDialogClose1' width="600px"
			:before-close="handleClose">

			<div class="elDialogContainer">

				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						直属领导姓名：
					</div>
					<el-input v-model="business_leaders.lead_name" placeholder="请输入直属领导姓名"></el-input>
				</div>
 
				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						直属领导职务：
					</div>
					<el-input v-model="business_leaders.lead_position" placeholder="请输入直属领导职务"></el-input>
				</div>

				<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
					<div class="text">
						直属领导介绍：
					</div>
					<el-input type="textarea" autosize placeholder="请输入直属领导介绍" v-model="business_leaders.txt">
					</el-input>
				</div>

				<div class="ipt" style="margin-bottom: 30px;">
					<div class="text">
						直属领导头像：
					</div>
					
					<el-upload class="avatar-uploader1" 
						action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3" :show-file-list="false"
						:on-success="handleAvatarSuccess5" :before-upload="beforeAvatarUpload">
						<img v-if="businessLeadersUrl" :src="businessLeadersUrl" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
					
				</div>

			</div>
			<div class="" style="display: flex;align-items: center;justify-content: flex-end;">
				<el-button type="primary" @click="submit2">保存</el-button>
			</div>
		</el-dialog> -->

		<!-- <div class="previewDialogVisible">
			<el-dialog :visible.sync="dialogVisible2" :show-close='false' width="600px" class="previewDialogVisible"
				@close='elDialogClose1'>
				<div class="previewElDialog elDialogContainer"
					style="background: #fff;background: #FFFFFF;border-radius: 10px;padding: 20px 0;">
					<img class="close" @click="dialogVisible2 = false" src="../img/close.png" alt="" />
					<div class=""
						style="line-height: 24px;font-size: 18px;color: #303133;font-weight: bold;padding: 0 20px;margin-bottom: 20px;">
						直属领导
					</div>
					<div class="elDialogContainer" style="background: #f7f9ff;padding: 20px 0;">
						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text">
								直属领导姓名：
							</div>
							<el-input v-model="business_leaders.lead_name" placeholder="请输入直属领导姓名"></el-input>
						</div>

						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text">
								直属领导职务：
							</div>
							<el-input v-model="business_leaders.lead_position" placeholder="请输入直属领导职务"></el-input>
						</div>

						<div class="ipt" style="align-items: baseline;padding: 0 20px;display: flex;">
							<div class="text">
								直属领导介绍：
							</div>
							<el-input type="textarea" autosize placeholder="请输入直属领导介绍" v-model="business_leaders.txt">
							</el-input>
						</div>

						<div class="ipt" style="padding: 0 20px;display: flex;">
							<div class="text">
								直属领导头像：
							</div>
							<div class="" style="display: flex;align-items: center;">
								<el-tooltip class="item" effect="dark" content="点击上传/更换图片" placement="right">
									<el-upload class="avatar-uploader1" style="width: 80px;height: 80px;"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess5"
										:before-upload="beforeAvatarUpload">
										<img v-if="businessLeadersUrl" :src="businessLeadersUrl" class="avatar5">
										<i v-else class="el-icon-plus avatar-uploader-icon"></i>
									</el-upload>
								</el-tooltip>
								<div class=""
									style="font-size: 14px;color: #999999;margin-right: 20px;margin-left: 20px;">
									<div class="" style="margin-bottom: 5px;">
										建议尺寸1:1，JPG、PNG格式
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class=""
						style="display: flex;align-items: center;justify-content: flex-end;padding: 20px 20px; 0 20px;">
						<el-button type="primary" @click="submit2">保存</el-button>
					</div>

				</div>
			</el-dialog>
		</div> -->


		<el-dialog title="期望求职者性格" :visible.sync="isque1" width="600px" :close-on-click-modal='false' :before-close="que1Close">
			<div class="elDialog">
				<div class="" style="font-weight: 400;font-size: 16px;color: #343232;">
					求职者最擅长的团队定位（按以下项目从高到低拖动排序）
				</div>
				<div class="drag">
					<section class="content">
						<draggable v-model="ques1" animation="400" @chang="change" @start="start" :move="move"
							@end="end">
							<!-- 列表样式 -->
							<div v-for="(item, index) in ques1" :key=index class="row">
								<span>{{ item.name }}</span>
								<!-- <span>（{{ item.id }}）</span> -->
							</div>
						</draggable>
					</section>
				</div>

				<div class="btnContainer1">
					<!-- <el-button type="primary">公司预览</el-button> -->
					<el-button type="primary" @click="que1open">保存</el-button>
				</div>
			</div>
		</el-dialog>

		<el-dialog title="求职期望匹配" :visible.sync="isque2" width="600px" :close-on-click-modal='false' :before-close="que2Close">
			<div class="elDialog">
				<div class="" style="font-weight: 400;font-size: 16px;color: #343232;">
					求职者最看重哪些回报?（按以下项目从高到低拖动排序）
				</div>
				<div class="drag">
					<section class="content">
						<draggable v-model="ques2" animation="400" @chang="change1" @start="start1" :move="move1"
							@end="end1">
							<!-- 列表样式 -->
							<div v-for="(item, index) in ques2" :key=index class="row">
								<span>{{ item.name }}</span>
								<!-- <span>（{{ item.id }}）</span> -->
							</div>
						</draggable>
					</section>
				</div>

				<div class="btnContainer1">
					<!-- <el-button type="primary">公司预览</el-button> -->
					<el-button type="primary" @click="que2open">保存</el-button>
				</div>
			</div>
		</el-dialog>


		<el-dialog :visible.sync="mapDialogVisible" title="选择地点" width="600px" :close-on-click-modal='false' :before-close="handleClose">
			<getMapLocation :addressArr='addressArr' @selectLocation='selectLocation' @close='close'
				@getCompanyInfo='getCompanyInfo'></getMapLocation>
		</el-dialog>



		<div class="previewDialogVisible">
			<el-dialog :visible.sync="previewDialogVisible" :close-on-click-modal='false' :show-close='false' width="800px"
				class="previewDialogVisible">
				<div class="previewElDialog">
					<img class="close" @click="previewCloseElDialog" src="../img/close.png" alt="" />
					<div class="main">
						<div class="title">职位预览</div>
						<div class="qrcodeContainer">
							<div class="qrcode">
								<div class="qrcodeImage">
									<img class="qrcodeImg" :src="qrcodeImg" alt="" />
									<img class="qrcodeLogo" src="https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2026/06/02/logopt.png" alt="" />
								</div>

								<div class="hite1">
									扫描<span style="color:#0084FF;">识别二维码</span>
								</div>
								<div class="hite2">
									可在手机上预览职位效果
								</div>
							</div>
						</div>
					</div>
				</div>
			</el-dialog>
		</div>
		
		

		<el-dialog title="职位分类" :visible.sync="dialogVisibleMultipleChoice6" :close-on-click-modal='false' :before-close="handleClose"
			@open='multipleOpen' @close='multipleClose' width="500px">
			<multipleChoice5 @submit='multiple6' @cancel='cancel' :selectList='job_title'
				:multipleChange='multipleChange'></multipleChoice5>
		</el-dialog>



		<el-dialog title="目标院校" ref="multipleChoice8" :close-on-click-modal='false' :visible.sync="dialogVisibleMultipleChoice2"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice8 @submit='multiple2' @cancel='cancel' :selectList='intend_school_name'
				:multipleChange='multipleChange'></multipleChoice8>
		</el-dialog>

		<el-dialog title="目标专业" ref="multipleChoice" :close-on-click-modal='false' :visible.sync="dialogVisibleMultipleChoice"
			:before-close="handleClose" @open='multipleOpen' @close='multipleClose' width="800px">
			<multipleChoice9 @submit='multiple' @cancel='cancel' :selectList='major_name'
				:multipleChange='multipleChange'></multipleChoice9>
		</el-dialog>

	</div>
</template>
<script>
	import getMapLocation from '../components/getMapLocation.vue'
	import {
		mapMutations,
		mapState
	} from 'vuex'
	import draggable from 'vuedraggable'
	import multipleChoice5 from '../components/multipleChoice6.vue'
	import Tinymce from '@/components/Tinymce' //保留
	import {
		trim
	} from 'jquery'
	import multipleChoice8 from '../components/multipleChoice8.vue'
	import multipleChoice9 from '../components/multipleChoice9.vue'
	const config = require('../../WebConfig')
	export default {
		components: {
			draggable,
			getMapLocation,
			multipleChoice5,
			Tinymce,
			multipleChoice8,
			multipleChoice9
		},
		data() {
			return {
				major_name:[],
				intend_school_name: [],
				
				dialogVisibleMultipleChoice2: false,
				dialogVisibleMultipleChoice: false,

				multipleChange: false,
				dialogVisibleMultipleChoice6: false,

				qrcodeImg: '',
				previewDialogVisible: false,
				mapDialogVisible: false,
				imageUrl: '',
				name: '',
				textarea1: '',
				options: [{
					value: '男',
					label: '1'
				}, {
					value: '女',
					label: '0'
				}],
				value: '',

				radio1: '全职',


				value1: '',
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now();
					},
				},

				salaryDisabled: true,

				salary1: '',
				salary2: '',

				salaryArry1: [],
				salaryArry2: [],
				salaryArry3: [],

				isshow: false,

				sys_area: [], //省份


				dialogVisible: false,
				dialogVisible1: false,

				addressList: [],
				addressArr: [],
				address: '',
				addressIndex:0,
				detailedAddress: '',
				// work_city: "武汉市",
				// work_county: "武昌区",
				// work_lat: 30.566404,
				// work_lng: 114.365112,
				// work_place: "湖北省武汉市武昌区楚天181文化创意产业园",
				// work_province: "湖北省",

				officeEnvironment1: '未添加',

				eduList: ["不限", "专科", "本科", "硕士", "博士"],
				workList1: ["双休", "单休", "大小休", "弹性休息"],
				workList: ["不加班", "偶尔加班", "经常加班"],
				overtimeList: ["不出差", "偶尔出差", "经常出差"],
				jobTypeList: [], //职位类型分类
				highlightsList: [], //标签列表
				jobTitleDisabled: true,
				ques1: [{
						name: '--开拓新业务:获得快速的结果、采取行动、喜好挑战',
						idx: 0,
						word: 'A'
					},
					{
						name: '--团队组织:热情乐观、采取行动、活跃团队气氛',
						idx: 1,
						word: 'B'
					},
					{
						name: '--运营优化:保证准确性、保持稳定性、对产品流程和细节精益求精',
						idx: 2,
						word: 'C'
					},
					{
						name: '--稳定执行:给予他人支持、团队精神、吃苦耐劳',
						idx: 3,
						word: 'D'
					},
				],
				ques2: [{
						name: '--有话语权的职位、晋升、高薪、荣誉感、胜利感',
						idx: 0,
						word: 'A'
					},
					{
						name: '--友好密切的同事关系、团建活动、展现才艺的机会',
						idx: 1,
						word: 'B'
					},
					{
						name: '--发挥专业特长、获取新知识、高质量的工作成果',
						idx: 2,
						word: 'C'
					},
					{
						name: '--稳定的环境、较少的冲突、诚挚的感谢、合作互助的氛围',
						idx: 3,
						word: 'D'
					}
				],

				ques1obj: {
					'A': {
						name: '--开拓新业务:获得快速的结果、采取行动、喜好挑战',
						idx: 0,
						word: 'A',
					},
					'B': {
						name: '--团队组织:热情乐观、采取行动、活跃团队气氛',
						idx: 1,
						word: 'B'
					},
					'C': {
						name: '--运营优化:保证准确性、保持稳定性、对产品流程和细节精益求精',
						idx: 2,
						word: 'C'
					},
					'D': {
						name: '--稳定执行:给予他人支持、团队精神、吃苦耐劳',
						idx: 3,
						word: 'D'
					}
				},
				ques2obj: {
					'A': {
						name: '--有话语权的职位、晋升、高薪、荣誉感、胜利感',
						idx: 0,
						word: 'A'
					},
					'B': {
						name: '--友好密切的同事关系、团建活动、展现才艺的机会',
						idx: 1,
						word: 'B'
					},
					'C': {
						name: '--发挥专业特长、获取新知识、高质量的工作成果',
						idx: 2,
						word: 'C'
					},
					'D': {
						name: '--稳定的环境、较少的冲突、诚挚的感谢、合作互助的氛围',
						idx: 3,
						word: 'D'
					}
				},

				//结算方式
				internMonthList: ['1个月', '2个月', '3个月', '4个月', '5个月', '6个月', '7个月', '8个月', '9个月', '10个月', '11个月', '12个月'],
				internDateList: ['1天', '2天', '3天', '4天', '5天', '6天', '7天'],

				internBecomingList: ['提供转正', '不提供转正', '面议'],
				internAccountList: ['日结', '周结', '月结', '完工'],
				parttimeCategoryList: ['周末/节假日', '寒暑假', '短期兼职', '长期兼职', '工作日'],
				pickerOptions1: {
					start: '06:00',
					step: '00:30',
					end: '23:30'
				},
				pickerOptions2: {
					start: '06:30',
					step: '00:30',
					end: '23:30',
				},

				job_type: 1, //招聘类型
				job_name: '', //职位名称
				job_title: '', //职位分类
				job_desc: '', //职位描述
				highlights: [], //职位标签

				// 领导人
				dialogVisible2: false,

				businessLeadersUrl: '',
				business_leaders: {
					lead_name: '',
					lead_position: '',
					text: '',
					url: [{
						id: 0,
						url: ''
					}]
				},
				salary: "面议", //薪资范围
				salary_max: 0,
				salary_min: 0,
				salary_composition: '', //薪资构成
				career_planning: '', //人才培养与发展规划
				education: '不限', //学历要求
				job_num: '1', //招聘人数
				// work_time: '', //工作时间
				startTime: '08:00',
				endTime: '17:30',

				job_end_time: '', //截止时间
				wayResting: '', //休息方式
				acceptance_of_overtime: '偶尔加班',
				acceptance_of_outwork: '偶尔出差',

				intern_month: '', //实习月数
				intern_date: '', //每周到岗天数
				intern_becoming_full: '', //转正机会

				intern_account_type: '', //结算方式

				parttime_category: '', //兼职类别
				isque1: false,
				isque2: false,

				isque1Select: false,
				isque2Select: false,

				id: 0,
				highlightsListAll: [],

				work_place: '',

				jobInfo: {},

				graduationDate:[],
				graduationDateList: [],

				academy_name: [], //学生所在学校
				isMeet:0,
				timer:null,
			};
		},
		mounted() {
			this.getgraduationDate()
			if (this.$route.query.id) {
				this.id = this.$route.query.id
				if(this.nextToken){
					this.getJobInfo()
				}
			}
			if (this.$route.query.isMeet) {
				this.isMeet = this.$route.query.isMeet
			}
			this.remoteMethod()
			this.getCompanyInfo()
			this.getkyjoblist()
			let arr = [{
				label: '面议',
				value: 0,
			}]
			for (let i = 1; i < 31; i++) {
				arr.push({
					label: i + 'K',
					value: i,
				})
			}
			// for (let i = 1; i < 15; i++) {
			// 	arr.push({
			// 		label: 30 + (i * 5) + 'K',
			// 		value: 30 + (i * 5),
			// 	})
			// }
			// for (let i = 1; i < 16; i++) {
			// 	arr.push({
			// 		label: 100 + (i * 10) + 'K',
			// 		value: 100 + (i * 10),
			// 	})
			// }
			this.salaryArry1 = arr
			this.salaryArry2 = arr.concat({
				label: '31K',
				value: 31
			})
			this.salaryArry3 = arr

			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
			
			
			setTimeout(()=>{
				this.getComIntend()
			},500)
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		filters:{
			cityfilters(val){
				if(val=='北京市‌'||val=='‌天津市‌‌'||val=='上海市'||val=='重庆市'||val=='澳门特别行政区'||val=='香港特别行政区'){
					return ''
				}
			}
		},
		watch: {
			job_title(val) {
				if (val !== '') {
					this.getHighlightsList(val)
					this.jobTitleDisabled = false
				} else {
					this.jobTitleDisabled = true
				}
			}
		},
		methods: {
			...mapMutations(['setIslogin']),
			selectChange(e){
				console.log(this.highlights)
				console.log(e[e.length-1]=='')
				if(e[e.length-1].trim()==''){
					
					this.highlights.splice(this.highlights.length-1,1)
				}
			},
			getComIntend(){
				this.$util.post(
					"v2/school_job/getComIntend", {
						admin_id:this.schoolInfo.admin_id,
					},
					(res) => {
						if(res.code==0){
							console.log(this.intend_school_name)
							console.log( res.data)
							if(res.data.intend_school_name!=''&&res.data.intend_school_name!='不限院校'){
								if(this.intend_school_name.length>0){
									
								}else{
									this.intend_school_name = res.data.intend_school_name.split(',')
								}
							}else{
								// this.intend_school_name = ['不限院校']
							}
							
							if(res.data.major_name!=''&&res.data.major_name!='不限专业'){
								if(this.major_name.length>0){
									
								}else{
									this.major_name = res.data.major_name.split(',')
								}
							}else{
								// this.major_name = ['不限专业']
							}
						}
					}
				);
			},
			
			
			saveComIntend(){
				let intend_school_name = ''
				let major_name = ''
				
				if(this.intend_school_name.length==0){
					intend_school_name = '不限院校'
				}else{
					intend_school_name = this.intend_school_name.join(',')
				}
				
				if(this.major_name.length==0){
					major_name = '不限专业'
				}else{
					major_name = this.major_name.join(',')
				}
				
				this.$util.post(
					"v2/school_job/saveComIntend", {
						admin_id:this.schoolInfo.admin_id,
						intend_school_name:intend_school_name,
						major_name:major_name
					},
					(res) => {
						
					}
				);
			},
			
			selectMajorBox() {
				this.dialogVisibleMultipleChoice = true
			},
			multiple(val) {
				this.dialogVisibleMultipleChoice = false
				this.major_name = val
			
				// this.getUserRecordList()
			},
			selectcityBox1() {
				this.dialogVisibleMultipleChoice2 = true
			},
			multiple2(val) {
				this.dialogVisibleMultipleChoice2 = false
				this.intend_school_name = val

				// this.getUserRecordList()
			},


			getgraduationDate() {
				let date = new Date(Date.now()).getFullYear() + '-09' + '-01 00:00:00'
				let timestamp = new Date(date).getTime()
				let nowtimestamp = Date.now()
				let arr = []
				let graduation = new Date(Date.now()).getFullYear().toString()
				if (nowtimestamp > timestamp) {
					arr.push(Number(graduation) + 1 + '届')
					arr.push(Number(graduation) + 2 + '届')
					arr.push(Number(graduation) + 3 + '届')
					arr.push(Number(graduation) + 4 + '届')
				} else {
					arr.push(Number(graduation) + '届')
					arr.push(Number(graduation) + 1 + '届')
					arr.push(Number(graduation) + 2 + '届')
					arr.push(Number(graduation) + 3 + '届')
				}
				// this.graduationDate = arr[0]
				// let array = arr.push('2028届','2029届','2030届')
				// console.log(array)
				this.graduationDateList = arr
				// console.log(this.graduationDateList)
			},

			cancel() {
				this.dialogVisibleMultipleChoice6 = false
				this.dialogVisibleMultipleChoice2 = false
				this.dialogVisibleMultipleChoice = false
			},
			multipleClose() {
				this.multipleChange = false
			},
			selectcityBox5() {
				this.dialogVisibleMultipleChoice6 = true
			},
			multiple6(val) {
				console.log(val)
				this.dialogVisibleMultipleChoice6 = false
				this.job_title = val

				this.jobTitleList = val
				this.highlights = []
				// this.getUserRecordList()
			},
			multipleOpen() {
				this.multipleChange = true
			}

			,
			async getQrcode() {
				if (this.id) {
					await this.publish(1)
					// &is_test=1
					this.$util.post(
						`admin/home/qrcode?app_type=10&not_login=1&page_path=pages/recruit/jobdetail&id=${this.id}&is_test=${config.IS_TEST}`, {
							// app_type: 7,
							// page_path: 'pages/recruit/companyInfo?admin_id=' + this.schoolInfo.admin_id,
						},
						(res) => {
							if (res.code == 200) {
								this.qrcodeImg = res.data.qrCode
								// this.sceneId = res.data.scene
								// this.setTimer()
								// localStorage.setItem('qrcodeImg', res.data.qrCode)
							}
							this.previewDialogVisible = true
						}
					);
				}
			},
			setJobNum(val) {
				if (val == '') {
					this.job_num = ''
				} 
				if(val>100){
					this.job_num = 100
				}
				if (val < 1) {
					this.job_num = 1
				}
			},
			previewPosition() {
				this.previewDialogVisible = true
			},
			previewCloseElDialog() {
				this.previewDialogVisible = false
			},
			// preview(){

			// },
			selectLocation(e) {

				this.addressArr.push({
					address: e.address,
					is_default: 0,
					work_city: e.work_city,
					work_county: e.work_county,
					work_lat: e.work_lat,
					work_lng: e.work_lng,
					work_province: e.work_province,
				})
				this.address_arr = this.addressArr.length
				this.mapDialogVisible = false
			},
			close() {
				this.mapDialogVisible = false
			},
			getJobInfo() {
				this.$util.post(
					"v2/school_job/getJobInfo", {
						id: this.id,
					},
					(res) => {

						if (res.code == 200) {

							this.jobInfo = res.data
							// let data = res.data
							this.job_type = res.data.job_type
							if (res.data.job_type == 1) {
								this.radio1 = '全职'
							} else if (res.data.job_type == 2) {
								this.radio1 = '实习'
							} else if (res.data.job_type == 3) {
								this.radio1 = '兼职'
							}

							// if (val == '全职') {
							// 	this.job_type = 1
							// } else if (val == '实习') {
							// 	this.job_type = 2
							// } else if (val == '兼职') {
							// 	this.job_type = 3
							// }

							this.job_name = res.data.job_name
							this.job_title = res.data.job_title
							this.job_desc = res.data.job_desc

							this.highlightsListAll.forEach((item) => {
								if (item.job_title === res.data.job_title) {
									this.highlightsList = item.job_tags.split(',')
								}
							})
							if (res.data.highlights != '') {
								this.highlights = res.data.highlights.split(',')
							} else {
								this.highlights = []
							}
							// if (res.data.direct_boss !== '') {
							// 	this.business_leaders = JSON.parse(res.data.direct_boss)
							// 	this.businessLeadersUrl = JSON.parse(res.data.direct_boss).url[0].url
							// }
							console.log(this.wayResting != '' || this.startTime !='' || this.endTime != '' || this.acceptance_of_overtime!= '')
							if (this.wayResting != '' || this.startTime !=
								'' || this.endTime != '' || this.acceptance_of_overtime!= '') {
								this.officeEnvironment1 = '已添加'
							}
							this.salary_max = res.data.salary_max
							this.salary_min = res.data.salary_min
							if (this.salary_min != 0 && this.salary_max != 0) {
								this.isshow = true
							}

							this.salary_composition = res.data.salary_composition
							this.career_planning = res.data.career_planning
							this.education = res.data.education
							this.job_num = res.data.job_num
							if (res.data.work_time != '') {
								this.startTime = res.data.work_time.split('-')[0]
								this.endTime = res.data.work_time.split('-')[1]
							}
							this.job_end_time = res.data.job_end_time
							this.wayResting = res.data.work_freedom
							this.acceptance_of_overtime = res.data.acceptance_of_overtime
							this.acceptance_of_outwork = res.data.acceptance_of_outwork
							// if(res.data.address_arr!==''){
							// 	this.addressArr = JSON.parse(res.data.address_arr)
							// }
							
							this.work_place = res.data.work_place
							console.log(res.data.graduation_year)
							if(res.data.graduation_year==''){
								this.graduationDate = []
							}else{
								this.graduationDate = res.data.graduation_year.split(',')
							}
							
							if(res.data.intend_school_name){
								this.intend_school_name = res.data.intend_school_name.split(',')
							}else{
								this.intend_school_name = []
							}
							if(res.data.major_name){
								this.major_name = res.data.major_name.split(',')
							}else{
								this.major_name = []
							}
							
							if (res.data.job_type == 2) {
								this.intern_month = res.data.intern_month
								this.intern_date = res.data.intern_date
								this.intern_becoming_full = res.data.intern_becoming_full
								this.intern_account_type = res.data.intern_account_type
								// obj.intern_month = this.intern_month
								// obj.intern_date = this.intern_date
								// obj.intern_becoming_full = this.intern_becoming_full
								// obj.intern_account_type = this.intern_account_type
							}

							if (res.data.job_type == 3) {
								this.parttime_category = res.data.parttime_category
								this.intern_account_type = res.data.intern_account_type
								// obj.parttime_category = this.parttime_category
								// obj.intern_account_type = this.intern_account_type
							}
							if (res.data.character_match) {
								this.isque1Select = true
							}
							if (res.data.job_match) {
								this.isque2Select = true
							}
							let character_match = res.data.character_match.split('')
							let job_match = res.data.job_match.split('')
							
							if (res.data.character_match) {
								let ques1 = []
								character_match.forEach((item) => {
									ques1.push(this.ques1obj[item])
								})
								this.ques1 = ques1

							}
							if (res.data.job_match) {
								let ques2 = []
								job_match.forEach((item) => {
									ques2.push(this.ques2obj[item])
								})
								this.ques2 = ques2
							}

						} else {
							this.$message.error(res.msg);
						}
						
						
						
					}
				);
			},
			// 防抖处理
			isRequest(duration = 2000) {
				if (this.request) return true;
				this.request = true;
				setTimeout(() => {
					this.request = false;
				}, duration)
				return false;
			},
			publish(idx) {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				
				// job_end_time
				if (this.isRequest()) return false;
				return new Promise((resolve) => {
					let obj = {
						id: this.id,
						admin_id: this.schoolInfo.admin_id,
						// id: this.schoolInfo.id,
					}
					this.job_name = this.job_name.trim()
					if (this.job_name == '') {
						this.$message.error('请填写职位名称');
						return
					}
					this.job_title = this.job_title.trim()
					if (this.job_title == '') {
						this.$message.error('请选择职位分类');
						return
					}
					this.job_desc = this.job_desc.trim()
					if (this.job_desc == '') {
						this.$message.error('请填写职位描述');
						return
					}

					if (this.job_num == '') {
						this.$message.error('请输入招聘人数');
						return
					}
					if (this.work_place == '') {
						this.$message.error('请选择工作地点');
						return
					}
					if (!this.startTime && !this.endTime) {
						this.$message.error('请选择工作时间');
						return
					}
					// if (this.salary_min != 0 && this.salary_max == 0) {
					// 	this.$message.error('请选择正确的薪资范围');
					// 	return
					// }
					obj.job_type = this.job_type

					obj.job_name = this.job_name
					obj.job_title = this.job_title
					obj.job_desc = this.job_desc
					obj.highlights = this.highlights.join(',')

					obj.direct_boss = JSON.stringify(this.business_leaders)
					obj.salary_max = this.salary_max

					obj.salary_min = this.salary_min
					if (this.salary_max == 0 && this.salary_min == 0) {
						obj.salary = '面议'
					} else if (this.salary_max == 0 && this.salary_min != 0) {
						obj.salary = this.salary_min + 'k+'
					} else {
						obj.salary = this.salary_min + '-' + this.salary_max + 'k'
					}
					obj.salary_composition = this.salary_composition
					obj.career_planning = this.career_planning
					obj.education = this.education
					obj.job_num = this.job_num
					obj.work_time = this.startTime + '-' + this.endTime
					obj.graduation_year = this.graduationDate.join(',')
					if (this.job_end_time != '') {
						obj.job_end_time = this.getTime(this.job_end_time)
					} else {
						obj.job_end_time = ''
					}
					obj.work_freedom = this.wayResting

					obj.acceptance_of_overtime = this.acceptance_of_overtime
					obj.acceptance_of_outwork = this.acceptance_of_outwork
					if (this.addressArr.length>0) {
						// obj.address_arr = JSON.stringify(this.addressArr)
						console.log(this.addressArr)
						obj.work_place = this.addressArr[this.addressIndex].work_province + this.addressArr[this
								.addressIndex]
							.work_city + this.addressArr[this.addressIndex].work_county + this.addressArr[this
								.addressIndex]
							.address

						obj.lat = this.addressArr[this.addressIndex].work_lat
						obj.lng = this.addressArr[this.addressIndex].work_lng

					} else {
						obj.work_place = this.work_place
						obj.lat = this.jobInfo.work_lat
						obj.lng = this.jobInfo.work_lng
					}

					if (this.job_type == 2) {
						obj.intern_month = this.intern_month
						obj.intern_date = this.intern_date
						obj.intern_becoming_full = this.intern_becoming_full
						obj.intern_account_type = this.intern_account_type
					}
					if (this.job_type == 3) {
						obj.parttime_category = this.parttime_category
						obj.intern_account_type = this.intern_account_type
					}

					let character_match = ''
					let job_match = ''
					// job_match:this.currentSelect.job_match || 'ABCD',
					// character_match:this.currentSelect.character_match || 'ABCD',
					this.ques1.forEach((item) => {
						character_match += item.word
					})
					this.ques2.forEach((item) => {
						job_match += item.word
					})
					if(this.intend_school_name.length==0){
						obj.intend_school_name = '不限院校'
					}else{
						obj.intend_school_name = this.intend_school_name.join(',')
					}
					
					if(this.major_name.length==0){
						obj.major_name = '不限专业'
					}else{
						obj.major_name = this.major_name.join(',')
					}
					// obj.major_name = this.major_name.join(',')
					
					
					obj.job_match = job_match
					obj.character_match = character_match
					this.$util.post(
						"v2/pc/publish", {
							...obj
						},
						(res) => {
							if (res.code == 0) {
								if (idx == 0) {
									this.$message({
										message: '保存成功',
										type: 'success',
										duration:1000
									});
									
									if(this.isMeet){
										let addMeetJob = localStorage.getItem('addMeetJob')
										if(addMeetJob){
											let arr = [...JSON.parse(addMeetJob),{job_id:res.data.id,job_num:this.job_num}]
											localStorage.setItem('addMeetJob',JSON.stringify(arr))
										}else{
											localStorage.setItem('addMeetJob',JSON.stringify([{job_id:res.data.id,job_num:this.job_num}]))
										}
									}
									
									// if(this.jobInfo&&this.jobInfo.sale_status==2){
									// 	this.delJob()
									// }	
									setTimeout(() => {
										this.$router.go(-1)
										// this.$router.push({
										// 	path: "/positionManagement",
										// });
									}, 1000)
								}
							} else {
								this.$message.error(res.msg);
							}
							this.saveComIntend()
							
							
							resolve()
						}
					);
				})
			},
			delJob(){
				this.$util.post(
					'v2/school_job/del_job', {
						id: this.id,
						sale_status: 1,
					},
					(res) => {
						if (res.code == 0) {
							
						}
					}
				)
			},
			
			getTime(dateStr) {
				// const dateTime = new Date(dateTimeString);
				// const year = dateTime.getUTCFullYear();
				// const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0');
				// const day = String(dateTime.getUTCDate()).padStart(2, '0');
				// const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				// const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				// const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				// const formattedDateTime = `${year}-${month}-${day}`;
				// const dateStr = 'Tue Oct 28 2025 00:00:00 GMT+0800';
				// const dateStr = 'Tue Oct 28 2025 00:00:00 GMT+0800';
				const date = new Date(dateStr);

				// 使用本地时间的各个部分
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');

				const result = `${year}-${month}-${day}`;
				// 2025-10-28
				return result
			},
			que1open() {
				this.isque1 = false
				this.isque1Select = true
			},
			que2open() {
				this.isque2 = false
				this.isque2Select = true
			},



			que1Close(done) {
				done();
			},
			que2Close(done) {
				done();
			},
			openque1() {
				this.isque1 = true
			},
			openque2() {
				this.isque2 = true
			},

			change(event) {

			},
			start(event) {


			},
			move(event, orgin) {


			},
			end(event) {


			},

			change1(event) {

			},
			start1(event) {


			},
			move1(event, orgin) {


			},
			end1(event) {



			},
			getCompanyInfo() {
				
				this.$util.post(
					"v2/school_job/getCompanyInfo", {
						admin_id: this.schoolInfo.admin_id,
					},
					(res) => {

						if (res.code == 200) {
							this.addressArr = res.data.address_arr
						}
					}
				);
			},
			getkyjoblist() {
				this.$util.get(
					"v2/getkyjoblist", {
						isOld: 1
					}, (res) => {
						if (res.code == 200) {

							let jobTypeList = []
							res.data.forEach((item) => {
								item.children.forEach((itm) => {
									if (itm.children) {
										jobTypeList.push(...itm.children)
									}
								})
							})
							let arr = []
							let arr1 = []

							jobTypeList.forEach((item) => {
								if (arr.indexOf(item.job_name) == -1) {
									arr.push(item.job_name)
									arr1.push(item)
								}
							})

							this.jobTypeList = arr1
							// this.jobTypeList = jobTypeList
							// this.jobTypeList
						} else {
							this.$message({
								showClose: true,
								message: res.msg,
								type: 'error'
							});
						}
					}
				);
			},
			//获取标签列表
			getHighlightsList(val) {
				this.$util.get1(
					"https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2023/09/04/skill_list.json", {},
					(res) => {
						this.highlightsListAll = res.item
						res.items.forEach((item) => {
							if (item.job_title === val) {
								console.log(item.job_tags.split(','))
								if(item.job_tags==''){
									this.highlightsList = []
								}else{
									this.highlightsList = item.job_tags.split(',')
								}
							}
						})

					}
				);
			},
			changeSalay1(val) {

				this.salary_max = ''
				if (val == 0) {
					this.isshow = false
				} else {
					this.isshow = true
				}
				let arr = []
				let array = JSON.parse(JSON.stringify(this.salaryArry3))
				arr = array.filter((item) => {
					return item.value > val
				})

				this.salaryDisabled = false
				this.salaryArry2 = arr
			},
			handleAvatarSuccess(res, file) {
				this.imageUrl = URL.createObjectURL(file.raw);
			},
			inputChange(val) {

				if (val == '全职') {
					this.job_type = 1
				} else if (val == '实习') {
					this.job_type = 2
				} else if (val == '兼职') {
					this.job_type = 3
				}
			},
			//获取城市列表
			remoteMethod() {
				this.$util.get1(
					"https://new-shengxue985.oss-cn-hangzhou.aliyuncs.com/2022/12/28/arealist.json?0.4693243637069089", {},
					(res) => {

						this.addressList = res.data
					}
				);
			},
			openDialogVisible() {
				this.dialogVisible = true
			},
			openDialogVisible1() {
				// this.dialogVisible1 = true
				this.mapDialogVisible = true
			},
			submitAddress1() {
				this.dialogVisible = false
				
				if (this.addressArr.length>0) {
					this.addressdialogVisible = false
				}else{
					this.$message({
						message: '请选择地址',
						type: 'error'
					});
				}

				if (this.addressIndex != -1) {
					this.work_place = this.addressArr[this.addressIndex].work_province + this.addressArr[this.addressIndex]
						.work_city + this.addressArr[this.addressIndex].work_county + this.addressArr[this.addressIndex]
						.address
				}
			},
			submitAddress() {

				this.addressArr.push({
					address: this.detailedAddress,
					is_default: 0,
					work_city: this.address[1],
					work_county: this.address[2],
					work_lat: 0,
					work_lng: 0,
					work_province: this.address[0],
				})
				this.dialogVisible1 = false
				this.address = ''
				this.detailedAddress = ''
			},
			changeAddressIndex(index) {
				this.addressIndex = index
				// this.dialogVisible = false
			},
			//直属领导
			elDialogClose1() {
				if (this.wayResting != '' || this.startTime !=
					'' || this.endTime != '' || this.acceptance_of_overtime!= '') {
					this.officeEnvironment1 = '已添加'
				} else {
					this.officeEnvironment1 = '未添加'
				}
				
			},
			handleClose(done) {
				done();
			},
			openDialogVisible2() {
				this.dialogVisible2 = true
			},
			handleAvatarSuccess5(res) {

				this.businessLeadersUrl = res.data.fileUrl;
				this.business_leaders.url[0].url = res.data.fileUrl
			},
			beforeAvatarUpload(file) {

				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}

				return isLt2M && img;
			},
			submit2() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				if(this.wayResting==''){
					this.$message.error('请填写休假制度');
				}else{
					this.dialogVisible2 = false
				}
				
				
				// this.business_leaders.lead_name = this.business_leaders.lead_name.trim()
				// this.business_leaders.lead_position = this.business_leaders.lead_position.trim()
				// this.business_leaders.text = this.business_leaders.text.trim()

				// if (this.business_leaders.lead_name && this.business_leaders.lead_position && this.business_leaders.text) {
				// 	this.dialogVisible2 = false
				// } else if (!this.business_leaders.lead_name && !this.business_leaders.lead_position && !this
				// 	.business_leaders.lead_position && !this.businessLeadersUrl) {
				// 	// this.dialogVisible2 = false    
				// 	this.$message.error('请填写直属领导信息！');

				// } else {
				// 	this.$message.error('请填写完整直属领导信息！');
				// }







			},
			
			isDebounce(duration = 500) {
			return new Promise(resolve => {
			  // 如果已有定时器，清除（重新计时）
			  if (this.timer) {
			    clearTimeout(this.timer);
			  }
			    // 开启新定时器
			    this.timer = setTimeout(() => {
			      resolve(); // 时间到 → 放行
			    }, duration);
			  });
			},
			async deleteAddress() {
				if (await this.isDebounce()) return; 
				console.log(this.addressIndex)
				if (this.addressArr.length>0) {
					let obj = {
						admin_id: this.schoolInfo.admin_id,
						id: this.schoolInfo.id,
					}
					this.addressArr.splice(this.addressIndex, 1)
					obj.address_arr = JSON.stringify([
						...this.addressArr,
					])
					this.$util.post(
						"v2/school_job/editCompany", {
							...obj
						},
						(res) => {

							if (res.code == 0) {
								this.$message({
									message: '删除成功',
									type: 'success'
								});
								this.getCompanyInfo()
								this.addressIndex = 0
							}
						})
				}else{
					this.$message({
						message: '请选择地址',
						type: 'error'
					});
				}

			},
		},
	};
</script>
<style>
</style>
<style lang="less" scoped>
	.drag {

		/* 根节点 */
		.content {
			width: 100%;
			max-height: 300px;
			// overflow-y: scroll;
			padding: 20px;
			background: #fff;
		}

		/* 列表样式,自行修改 */
		.row {
			background: rgb(241, 241, 241);
			padding: 10px;
			margin-bottom: 10px;
			border-radius: 10px;
			cursor: move;
			/* 鼠标手势 */
		}
	}

	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: bold;
					font-size: 16px;
					color: #333;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 0 0 0;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				.avatarContainer {
					display: flex;
					// align-items: center;
					align-items: flex-start;
					margin-bottom: 30px;

					.text {
						width: 100px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #333333;
						margin-right: 20px;
					}

					.upload {
						margin-right: 20px;
					}

					.uploadContainer {
						display: flex;
						align-items: center;

						.uploadText {
							width: 310px;
							font-weight: 500;
							font-size: 16px;
							color: #999999;
						}
					}

				}

				.ipt {
					width: 700px;
					display: flex;
					align-items: center;
					margin-bottom: 28px;

					.text {
						width: 126px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						margin-right: 10px;
						// position: relative;
						justify-content: flex-end;

						span {
							// position: absolute;
							// left: -10px;

						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
					}

					.el-date-editor {
						flex: 1 !important;
					}
				}

			}

			.btnContainer {
				width: 700px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;

				.preview {
					// background-color: #5DB0FE !important;
					// border-color: #5DB0FE !important;
				}

				.submit {
					// background-color: #0084FF !important;
					// border-color: #0084FF !important;
				}

				.el-button--primary {
					// border-radius: 10px !important;
				}

			}
		}


		.addressList {
			padding-top: 20px;

			.item {
				display: flex;
				align-items: center;
				border-bottom: 1px solid #EEEEEE;
				padding: 10px 20px;
				margin-bottom: 20px;

				.addressLeft {
					flex: 1;

					.top {
						font-weight: bold;
						font-size: 16px;
						color: #343232;
						margin-bottom: 5px;
					}

					.bottom {
						font-weight: 500;
						font-size: 16px;
						color: #343232;
					}
				}

				.addressRight {
					font-size: 0;
					cursor: pointer;

					img {
						width: 20px;
						height: 20px;
					}
				}
			}
		}

		.ipt {
			width: 560px;
			display: flex;
			align-items: center;
			margin-bottom: 28px;

			.text {
				// width: 135px;
				display: flex;
				align-items: center;
				font-weight: 400;
				font-size: 14px;
				color: #333333;
				margin-right: 20px;
			}

			.el-input {
				flex: 1 !important;
			}

			.el-select {
				flex: 1 !important;
			}

			.el-textarea {
				flex: 1 !important;
			}

			.el-date-editor {
				flex: 1 !important;
			}

			.el-cascader {
				flex: 1 !important;
			}
		}
	}

	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
		cursor: pointer;

		overflow: hidden;

		text-overflow: ellipsis;

		white-space: nowrap;
		width: 500px;
	}

	.previewElDialog {
		position: relative;
		font-size: 0;

		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #FFFFFF;
			border-radius: 10px;

			.title {
				font-weight: bold;
				font-size: 24px;
				color: #2A2929;
				margin-bottom: 30px;
			}
		}

		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}

	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.qrcode {
			padding: 50px 100px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;

			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;

			.qrcodeImage { position: relative; width: 208px; height: 245px; }
			.qrcodeImg {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}
			.qrcodeLogo { position: absolute; top: 0; left: 0; right: 0; width: 90px; height: 90px; border-radius: 50%; margin: 58px auto; }

			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}

			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}

	.btnContainer1 {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: flex-end;
		padding-right: 20px;
	}


	.majorbox {
		flex: 1;
		width: 165px;
		border-radius: 4px;
		border: 1px solid #DCDFE6;
		cursor: pointer;
		display: flex;
		align-items: center;
		padding: 0 10px 0 15px;
	}

	.majorbox:hover {
		border: 1px solid #c0c4cc;
	}

	.majorBox {
		// width: 200px;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		color: #606266;
		flex: 1;

	}

	// .majorBox:hover {
	// 	border: 1px solid #c0c4cc;
	// }
	.majorBox1 {
		flex: 1;
		border-radius: 4px;
		// border: 1px solid #DCDFE6;
		width: 165px;
		height: 40px;
		padding: 0 5px 0 15px;
		line-height: 40px;
		font-size: 14px;
		color: #666;
		text-align: right;
		cursor: pointer;
	}

	.majorBox1:hover {
		// border: 1px solid #c0c4cc;
	}
</style>

<style>
	#register .el-input__inner {
		font-size: 16px;
	}

	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		/* margin-bottom: 5px; */
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	#addPosition .avatar {
		width: 178px;
		height: 178px;
		display: block;
	}


	.environment {
		border: 1px solid #DCDFE6;
		flex: 1;
		background-color: #FFF;
		color: #606266;
		height: 40px;
		padding: 0 15px;
		border-radius: 4px;
		font-size: 14px;
		line-height: 40px;
		display: flex;
		align-items: center;

	}



	#addPosition .avatar-uploader1 .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader1 .el-upload:hover {
		border-color: #409EFF;
	}


	#addPosition .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 80px;
		height: 80px;
		line-height: 80px;
		text-align: center;
	}

	#addPosition .avatar {
		width: 120px;
		height: 120px;
		display: block;
	}


	#addPosition .previewDialogVisible .el-dialog {
		background: initial;
		box-shadow: initial;
	}

	.avatar5 {
		width: 80px;
		height: 80px;
	}
</style>
